import axios from 'axios';
import Account from '../models/Account';
import request from '../shared/http';
import API_CONFIG from '../config/api.config';

const cache = {};

class AuthService {
  getURL() {
    return '/accounts/@me';
  }

  async authenticate(id, password) {
    await request.post('/authenticate', {
      username: id,
      password,
    });
  }

  async createAccount({
    firstName,
    lastName,
    mobile,
    password,
    mobileVerificationId,
    mobileVerificationCode,
  }) {
    const domain = API_CONFIG.BASE_URL;
  const url = `${domain}/signup`;
  const payload = new URLSearchParams();
  payload.append('first_name', firstName);
  payload.append('last_name', lastName);
  payload.append('mobile', mobile);
  payload.append('password', password);
  payload.append('mobile_verification_id', mobileVerificationId);
  payload.append('mobile_verification_code', mobileVerificationCode);
  payload.append('type', 'user');
   const response = await axios.post(url, payload, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    withCredentials: true,
  });
    cache.account = new Account({
      firstName,
      lastName,
    });
    return response;
  }

  async UpdateAccount({
    mobile,
    mobileVerificationCode,
    mobileVerificationId,
  }) {
    // const url = "/accounts/@me";
    const response = await request.put(this.getURL(), {
      mobile,
      mobile_verifiaction_id: mobileVerificationId,
      mobile_verification_code: mobileVerificationCode,
    });
    return response;
  }

  async createEmailVerificationCode(mobile) {
    const response = await axios({
      method: 'POST',
      url: '/w1/auth/verification',
      data: { login_id: mobile.trim() },
    });
    return response.data.data.id;
  }

  async signupVerificationCode( mobile, firstName) {
    const payload = {};

    if (mobile) {
      payload.login_mobile = mobile.trim();
    }
    if (firstName) {
      payload.first_name = firstName;
    }
    const url = '/auth/userverification';
    const { data } = await request.post(url, payload)
    return data;
  }

  async googleSignupVerificationCode(mobile) {
    const response = await axios({
      method: 'POST',
      url: '/w1/auth/userverification',
      data: { login_mobile: mobile },
    });
    return response.data.data.id;
  }

  async resetPassword({
    verificationId, verificationCode, loginId, password,
  }) {
    const payload = {
      verification_id: verificationId,
      verification_code: verificationCode,
      login_id: loginId,
      password,
    };
    const response = await axios.post('/w1/auth/reset-password', payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  }
}

export default new AuthService();
